import React from "react";
import { CountryIndicator, countryIndicators } from "@domain/currentProfile/countriesIndicators";
import { Selecter } from "./selecter";

interface IndicatorDataListProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "onChange"> {
	value?: CountryIndicator;
	onChange: (value: CountryIndicator) => void;
	menuHeight?: number;
}

export const IndicatorDataList: React.FC<IndicatorDataListProps> = ({ value, onChange, menuHeight = 220 }) => {
	return (
		<Selecter
			value={value}
			menuHeight={menuHeight}
			options={Object.keys(countryIndicators).map((indicator) => ({ label: `+${indicator}`, value: indicator }))}
			onChange={(v) => onChange(v as CountryIndicator)}
		/>
	);
};
